// extracted by mini-css-extract-plugin
export default {"HeroContent":"HeroContent_HeroContent__kaL-T","HeroContent__title":"HeroContent_HeroContent__title__T9VAB","HeroContent__text":"HeroContent_HeroContent__text__yfdOq"};